import { memoizePromise } from "./memoize-promise";
import { parentApi } from "./message-proxy";
import { XMLHttpRequest } from "./xhr";

export function patchFetch() {
  const data = __WEBSIM_DATA__;

  // Flag to check if fetch has already been patched
  if ((window as any).fetchPatched) {
    return;
  }
  const originalFetch = window.fetch;

  window.XMLHttpRequest = XMLHttpRequest;

  const getFetchParams = memoizePromise(parentApi.getFetchParams);

  window.fetch = async function (a, options = {}) {
    const url = new URL(
      (a as Request)?.url ? String((a as Request).url) : String(a),
      window.location.origin
    );

    const isOwnOrWebsimOrigin =
      url.origin === window.location.origin ||
      url.origin === "https://websim.com" ||
      url.origin === data.hostOrigin;

    // Only proxy requests to our own origin or websim.com
    if (!isOwnOrWebsimOrigin) {
      return originalFetch(url, options);
    }

    const isRealApi = url.pathname.startsWith("/api/v1/");
    // HACK: This `/internal/api/v1/` path doesn't actually exist. It gets
    // rewritten to the actual endpoint in the host handler.
    const isMockInternalApi = url.pathname.startsWith("/internal/api/v1/");
    const isGenerativeApi = url.pathname.startsWith("/api/") && !isRealApi;

    // Check if this is an API request we should proxy to the host
    const shouldProxyRequest =
      isRealApi || isMockInternalApi || isGenerativeApi;
    if (!shouldProxyRequest) {
      return originalFetch(url, options);
    }

    if (!(options.headers instanceof Headers)) {
      options.headers = new Headers(options.headers);
    }

    options.headers = Object.fromEntries(options.headers);

    if (isGenerativeApi) {
      const { websimUpdateVersion } = await getFetchParams();
      options.headers["Websim-Update"] = `${websimUpdateVersion}`;
    }

    const {
      body,
      method,
      headers,
      mode,
      credentials,
      cache,
      redirect,
      referrer,
      referrerPolicy,
      integrity,
      keepalive,
    } = options;

    const response = await parentApi.fetchApi({
      url: url.toString(),
      options: {
        body,
        method,
        headers,
        mode,
        credentials,
        cache,
        redirect,
        referrer,
        referrerPolicy,
        integrity,
        keepalive,
      },
    });

    return new Response(response.body, response);
  };

  // Set the flag to indicate that fetch has been patched
  (window as any).fetchPatched = true;
}
